import { SliderProps } from './Slider.types'
import { SliderRoot } from './Slider.styles'

const Slider = ({ min = 0, max = 32000, ...props }: SliderProps) => {
    return <SliderRoot min={min} max={max} {...props} />
}

export default Slider
